import React from "react";

export const FounderQuote = () => {
  return (
    <section
      className="bg-cream w-full px-6 sm:px-10 lg:px-16 py-28 sm:py-36 lg:py-44"
      data-testid="founder-quote-section"
    >
      <figure className="max-w-prose3 mx-auto text-center">
        {/* Large hanging quotation mark */}
        <div
          className="display-serif text-gold leading-none mb-4"
          style={{ fontSize: "6rem" }}
          aria-hidden="true"
        >
          &ldquo;
        </div>

        <blockquote
          className="display-serif text-nearblack text-2xl sm:text-3xl lg:text-4xl leading-[1.25] italic font-light mb-10"
          data-testid="founder-quote-text"
        >
          I built this so my own scripts could face honest critique before the room did.
          Voxium Script tells you what it sees — clearly, in voice, without softening.
          That's the work.
        </blockquote>

        {/* Hairline above attribution */}
        <div className="w-12 h-px bg-gold mx-auto mb-6" />

        <figcaption
          className="font-ui text-sm tracking-wide text-nearblack/65"
          data-testid="founder-quote-attribution"
        >
          <span className="text-nearblack">Alain Raymond</span>
          <span className="mx-2 text-nearblack/40">·</span>
          <span className="italic">founder</span>
        </figcaption>
      </figure>
    </section>
  );
};

export default FounderQuote;
